import React from 'react'
import { useQueryPaginator } from 'src/components/Table'
import { PalletDialog } from 'src/modules/supply_chain/components/PalletDialog'
import { skuit } from 'src/services/skuit'

import { PalletListTable } from 'src/components/Table/list/Pallet'
import { ListPage } from 'src/components/Pages/ListPage'

export const PalletListPage = () => {
  const paginator = useQueryPaginator('pallet-list', skuit.sc.pallets.list)

  const exportFields = [
    'asn',
    'bill_of_lading_number',
    'client_guid',
    'client_name',
    'client_uid',
    'created_on',
    'facility',
    'for_shipping',
    'guid',
    'name',
    'path',
    'skus',
  ]

  return (
    <ListPage
      title="Pallets"
      paginator={paginator}
      dialogs={[{ title: 'New Pallet', Dialog: PalletDialog }]}
    >
      <PalletListTable
        paginator={paginator}
        fields={['name', 'client', 'clientID', 'skus', 'path', 'totalUnits', 'batch', 'asn', 'reviewNeeded']}
        bulkActions={['printPallet']}
        exportConfig={{
          exportFields: exportFields,
          exportAPI: skuit.sc.pallets.export,
        }}
      />
    </ListPage>
  )
}
